import React from 'react';
import type { Nullable } from 'corgi-types';

import ImageOption from '../../ImageOption';

interface ImageProps {
  title: string;
  url: Nullable<string>;
  disabled: boolean;
}

const IMAGE_OPTION_SIZE = 34;

const Image = ({ title, url, disabled }: ImageProps) => (
  <ImageOption size={IMAGE_OPTION_SIZE} alt={title} url={url} disabled={disabled} />
);

export default Image;
